import * as React from 'react'
import { memo } from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="currentColor" {...props}>
    <path
      fill="currentColor"
      d="M10 44v-4h12v-8h-4c-2.767 0-5.125-.975-7.074-2.926C8.976 27.124 8.001 24.765 8 22c0-2 .55-3.841 1.65-5.524A9.529 9.529 0 0 1 14.1 12.8c.3-2.5 1.392-4.591 3.276-6.274C19.26 4.843 21.468 4.001 24 4c2.532-.001 4.74.84 6.626 2.526 1.885 1.685 2.977 3.777 3.274 6.274a9.513 9.513 0 0 1 4.45 3.676A9.898 9.898 0 0 1 40 22c0 2.767-.975 5.125-2.926 7.076-1.95 1.95-4.309 2.925-7.074 2.924h-4v8h12v4H10Zm8-16h12c1.667 0 3.083-.583 4.25-1.75C35.417 25.083 36 23.667 36 22c0-1.2-.342-2.3-1.026-3.3a6.045 6.045 0 0 0-2.674-2.2l-2.1-.9-.3-2.3c-.2-1.5-.858-2.759-1.974-3.776S25.501 7.999 24 8c-1.501.001-2.81.51-3.926 1.526S18.3 11.8 18.1 13.3l-.3 2.3-2.1.9a6.03 6.03 0 0 0-2.674 2.2A5.74 5.74 0 0 0 12 22c0 1.667.583 3.083 1.75 4.25C14.917 27.417 16.333 28 18 28Z"
    />
  </svg>
)
const Memo = memo(SvgComponent)
export default Memo
